import React from 'react';
import './UserHeader.css';


const UserHeader = () => {
    return (
        <header className="user-header">
            
        </header>
    );
};

export default UserHeader;
